/**
 * @file
 * Attaches behaviors for Reset Button for Views.
 */

!((document, $) => {
  'use strict';
  Drupal.behaviors.BandeauVideoManager = {
    attach: function attach(context) {
      let $video = $(context).find('.paragraph--type--bandeau-video--modal video');
      let $btnPlay = $(context).find('.paragraph--type--bandeau-video .image-play-button-container');
      let $closeBtn = $(context).find('.paragraph--type--bandeau-video--modal .uk-modal-close-full');

      $closeBtn.click(function (){
        $video.get(0).pause();
      });

      $btnPlay.click(function (){
        $video.get(0).play();
      });
    }
  };
})(document, jQuery);
